import React, { useState } from 'react';
import Modal from '../../../components/orizon-ui/Modal';
import { FormSection } from '../../../components/orizon-ui/FormField';
import CompatibilitaPanel from './CompatibilitaPanel';

/**
 * Modale separato con la sola sezione "Compatibilità con i componenti" di un articolo.
 * Riusa CompatibilitaPanel (lo stesso del dettaglio articolo): stessa tabella, stessa paginazione,
 * "Associa componente", modifica e rimozione dei legami.
 *
 * Chiusura con Esc, click sullo sfondo e X (come gli altri modali); su mobile è un bottom-sheet.
 * Mentre è aperto il modale di associazione, la chiusura di questo è sospesa (così Esc chiude solo quello sopra).
 * onCambiato() viene chiamato dopo ogni associazione / modifica / rimozione, per aggiornare la tabella Ricambi.
 */
const CompatibilitaModal = ({ articolo, onClose, onCambiato }) => {
  const [formAperto, setFormAperto] = useState(false);

  return (
    <Modal
      isOpen
      onClose={onClose}
      titolo={articolo.nome}
      etichetta={`Compatibilità · EAN ${articolo.ean}`}
      larghezza="xl"
      bloccaChiusura={formAperto}
    >
      <FormSection titolo="Compatibilità con i componenti" icona="Link2">
        <CompatibilitaPanel
          articolo={articolo}
          onCambiato={onCambiato}
          onModaleChange={setFormAperto}
        />
      </FormSection>
    </Modal>
  );
};

export default CompatibilitaModal;
